import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { type MaxSummaryWithLocation } from '../../shared/types';
import { getAdminMaxSummaries } from '../utilities/api';

export const queryKeys = {
    getAdminMaxSummaries: () => ['admin', 'max-summaries', 'get'],
};

export const useAdminMaxSummaries = (): UseQueryResult<MaxSummaryWithLocation[], Error> => {
    return useQuery({ queryKey: queryKeys.getAdminMaxSummaries(), queryFn: getAdminMaxSummaries, staleTime: Infinity });
};
